import i18next from 'lib/i18n'

import './style.scss'

const PageLoading = () => {
  return (
    <div className="PageLoader">
      <img className="PageLoader__logo" src="/images/app-logo-3.svg" />
      <div className="PageLoader__text">{i18next.t('common.loading')}</div>
    </div>
  )
}

export default PageLoading
